import { render, staticRenderFns } from "./user_profile_basic.vue?vue&type=template&id=f3ab8c34&scoped=true&"
import script from "./user_profile_basic.vue?vue&type=script&lang=ts&"
export * from "./user_profile_basic.vue?vue&type=script&lang=ts&"
import style0 from "./user_profile_basic.vue?vue&type=style&index=0&id=f3ab8c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ab8c34",
  null
  
)

export default component.exports